module.exports = __webpack_public_path__ + "static/img/MO.de125e0b.svg";